module.exports = __webpack_public_path__ + "img/testimonials-bg.00aa0193.jpg";